import { createSlice } from "@reduxjs/toolkit";

/**
 * Auswahl der Erlebnisreisen-Suche
 * ================================
 *
 * Art, Sportart und Kontinent lagen im lokalen State zweier Komponenten --
 * IndividualToursInputs (Art, Sportart) und IndividualSection (Kontinent).
 * Lokaler State ueberlebt kein Aushaengen: sobald eine der beiden auch nur
 * kurz aus dem Baum fiel, stand die Suche wieder auf "Alle", obwohl die
 * Trefferliste noch die alte Auswahl zeigte.
 *
 * Hier liegen sie an einer Stelle, unabhaengig davon, wer sie gerade
 * darstellt. Die Trefferliste selbst bleibt bewusst lokal -- sie ist gross,
 * kurzlebig und interessiert sonst niemanden.
 *
 * Ein Neuladen der Seite setzt weiterhin zurueck; wer das nicht will, muss die
 * Auswahl in die URL schreiben. Das ist bewusst nicht hier geloest.
 */

const initialState = {
  eventType: "",
  category: "",
  continent: "",
  // Hat der Reisende den Zeitraum in den Erlebnisreisen selbst angefasst?
  // travelDate liegt global im searchSlice und wird von Pauschal, Hotel und
  // Erlebnis geteilt. Wir belegen ihn hier vor, duerfen aber nicht die
  // Eingabe ueberschreiben, sobald jemand hin- und herklickt.
  datesTouched: false,
};

const individualSearchSlice = createSlice({
  name: "individualSearch",
  initialState,
  reducers: {
    setEventType(state, { payload }) {
      state.eventType = payload || "";
      // Die Sportart haengt an der Art. Bleibt sie beim Wechsel stehen, filtert
      // die Suche nach etwas, das es in der neuen Art nicht gibt.
      state.category = "";
    },
    setCategory(state, { payload }) {
      state.category = payload || "";
    },
    setContinent(state, { payload }) {
      state.continent = payload || "";
    },
    markDatesTouched(state) {
      state.datesTouched = true;
    },
    resetIndividualSearch() {
      return initialState;
    },
  },
});

export const {
  setEventType,
  setCategory,
  setContinent,
  markDatesTouched,
  resetIndividualSearch,
} = individualSearchSlice.actions;

export default individualSearchSlice.reducer;

export const selectIndividualSearch = (state) => state.individualSearch;
